import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getMovementPageData } from './api';
import type { MovementPageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: MovementPageDataContext,
	Provider: MovementPageDataContextProvider,
	useContext: useMovementPageData,
	useAsyncData: useMovementPageDataFromApi,
	prefetchAsyncData: prefetchMovementPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'MovementPageDataContext',
	dataProperty: 'pageData',
	getData: getMovementPageData,
	getUniqueId: (slug) => slug,
	hasUserData: true, // for the share links, built based on the current user
	errorHandler: pageDataErrorHandler<MovementPageDataErrorCode>(),
});
